import crudActions from '../crud/actions'

const actions = crudActions('CUSTOM_MEDICATIONS_')

export default actions
